import Vue from 'vue';
import { parseISO } from 'date-fns';
import Errors from '../classes/Errors';
import gsap from 'gsap';

Vue.component('countdown-component', {
    props: [
        'deadline',
        'fillColor'
    ],
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            total: null,
            seconds: 0,
            minutes: 0,
            hours: 0,
            days: 0,
            deadlineReached: false,
            parsedDeadline: '',
            secondsArray: [],
            nextNumber: null,
            nextnextNumber: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        const result = parseISO(
            this.deadline.date,
            'yyyy-MM-dd hh:mm:ss',
            new Date()
        );
        this.parsedDeadline = result;

        this.remainder = this.remainingTime(this.deadline);
        this.updateCountdown();
        this.timeinterval = setInterval(this.updateCountdown, 1000);
        this.secondsArray = this.prepareSeconds();
        this.countdownSlide();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        prepareSeconds() {
            const seconds = [];
            for (let i = 0; i < 60; i++) {
                if (i < 10) {
                    seconds.push(`0${i}`);
                    continue;
                }

                seconds.push(`${i}`);
            }

            return seconds;
        },

        remainingTime(deadline) {
            this.total = Date.parse(deadline) - Date.parse(new Date());

            if (this.total <= 0) {
                EventBus.$emit('deadline-has-expired', true);
                this.deadlineReached = true;

                this.seconds = 0;
                this.minutes = 0;
                this.hours = 0;
                this.days = 0;

                return;
            }

            this.seconds = Number(('0' + Math.floor((this.total / 1000) % 60)).slice(-2));
            this.minutes = Number(('0' + Math.floor((this.total / 1000 / 60) % 60)).slice(-2));
            this.hours = Number(('0' + Math.floor((this.total / (1000 * 60 * 60)) % 24)).slice(-2));
            this.days = Number('0' + Math.floor(this.total / (1000 * 60 * 60 * 24)));
        },

        updateCountdown() {
            this.remainingTime(this.parsedDeadline);
        },

        slideFunction() {
            var numberSlot = document.getElementById('numberSlot');

            // The interval can outlive the DOM during page transitions; bail
            // out gracefully if the target element has already been removed.
            if (!numberSlot) {
                clearInterval(this.slideInterval);
                return;
            }

            this.prevNumber = this.seconds + 1;
            this.prevprevNumber = this.prevNumber + 1;
            this.nextNumber = this.seconds - 1;
            this.nextnextNumber = this.nextNumber - 1;

            if (this.seconds == 58) {
                this.prevprevNumber = 0
                this.prevNumber = 59;
            }
            else if (this.seconds == 59) {
                this.prevNumber = 0;
                this.prevprevNumber = 1
            } else if (this.seconds == 0) {
                this.nextNumber = 59;
                this.nextnextNumber = 58;
            } else if (this.seconds == 1) {
                this.nextNumber = 0;
                this.nextnextNumber = 59;
            }

            if (this.$root.isMobile) {
                return;
            }

            numberSlot.innerHTML =
                '<div class="number move-number-out">' + (this.prevprevNumber < 10 ? '0' + this.prevprevNumber : this.prevprevNumber) + '</div>' +
                '<div class="number">' + (this.prevNumber < 10 ? '0' + this.prevNumber : this.prevNumber) + '</div>' +
                '<div class="number active">' + (this.seconds < 10 ? '0' + this.seconds : this.seconds) + '</div>' +
                '<div class="number">' + (this.nextNumber < 10 ? '0' + this.nextNumber : this.nextNumber) + '</div>' +
                '<div class="number">' + (this.nextnextNumber < 10 ? '0' + this.nextnextNumber : this.nextnextNumber) + '</div>';

            gsap.to('.number.active', { color: this.fillColor, delay: 0.2, duration: 0.1 });
        },

        countdownSlide() {
            if (!this.deadlineReached) {
                this.slideInterval = setInterval(this.slideFunction, 1000);
            } else {
                var numberSlot = document.getElementById('numberSlot');
                if (!numberSlot) {
                    return;
                }

                numberSlot.innerHTML =
                    '<div class="number move-number-out deadline-reached"> 02 </div>' +
                    '<div class="number"> 01 </div>' +
                    '<div class="number active"> 00 </div>' +
                    '<div class="number"> 59 </div>' +
                    '<div class="number"> 58 </div>';
            }
        }
    },

    beforeDestroy() {
        clearInterval(this.slideInterval);
        clearInterval(this.timeinterval);
    }
});
